var angular = require('angular');
var PortalAPI = require('../api').Portal;
var UserAPI = require('../api').User;
var Promise = require('bluebird');

module.exports = SignupController;

function SignupController($scope, $stateParams, $location, gRecaptcha) {

	var vm = this;
	vm.user = {
		answers: {}
	};

	vm.initialLoad = true;
	vm.loading = false;
	vm.questions = [];

	vm.submitted = false;
    vm.error = null;
    vm.applicantOrganisationsLink = window.conf.cms_url + 'what-is-the-good-exchange/for-applicant-organisations/';
	vm.gRecaptcha = gRecaptcha;

	vm.init = function() {
		var recaptchaPublicKey = window.conf.recaptcha_public_key;
		vm.gRecaptcha.initialize({key: recaptchaPublicKey});

		vm.loading = true;
		UserAPI.GetQuestions()
			.then(function(questions) {
				vm.loading = vm.initialLoad = false;
				vm.questions = questions;
			})
			.catch(function() {
				vm.loading = vm.initialLoad = false;
			});
	};

	vm.init();

	vm.submitSignup = function() {
		var user = vm.user;

		user.gdprAnswers = [];

		for (var property in user.answers) {
			if (user.answers.hasOwnProperty(property)) {
				user.gdprAnswers.push({
					QuestionId: property,
					Answer: user.answers[property]
				});
			}
		}

		vm.gRecaptcha.execute({action: 'selfRegistration'})
			.then(function (token) {
				// returns token from Google Recaptcha

				return PortalAPI.signup({
						first_name: user.first,
						last_name: user.last,
						email: user.email,
						password: user.password,
						originator: $location.search().originator,
						gdprAnswers: user.gdprAnswers,
						isApplicant: vm.isApplicant,
						reCaptchaToken: token
					})
					.then(function(resp) {
						vm.error = null;
						vm.submitted = true;
					})
					.catch(function(resp) {
						vm.error = (resp != null) && (resp.body != null) ? resp.body.error : null;
						if (vm.error == null){
							vm.error = "Unknown Error";
						}
					});
		});
	};
}
